import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Edit, TrashAlt } from '@styled-icons/boxicons-solid'

import Pagination from '../common/Pagination'
import { ProgresSpinner } from '../common/ProgresSpinner'
import LinkWithStatus from '../common/LinkWithStatus'
import { useSearchParams } from 'react-router-dom'
import { deleteRequest } from '../../services/base'
import NoRecordsFound from '../common/NoRecordsFound'

const BlockedVehicleRow = (props) => {
  const blockers = props.blockers
  const messages = {
    wire_list: 'Importing Wirelist',
    dtcs: 'Importing DTCs',
    modules: 'Importing Modules',
    inlines: 'Importing Inlines',
    category_connector: 'Importing Connector Categories',
    harness_description: 'Importing Harness Descriptions',
    sig_list: 'Importing Circuit List',
    device_connections: 'Importing Device Connecitons',
  }

  const state = blockers.map((b) => messages[b.name]).join('. ')

  return (
    <div className="w-2/3 font-light justify-end space-x-5 flex pr-5">
      <ProgresSpinner caption={state} />
    </div>
  )
}

const VehicleRow = (props) => {
  const vehicle = props.vehicle
  const blockers = (vehicle.blockers || []).filter(
    (b) => b.name !== 'graph_reset'
  )
  const vehicleIsBlocked = blockers.length > 0

  return (
    <div className="flex flex-row items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue">
      <div className="w-1/3">
        <div className="font-medium"> {vehicle.name} </div>
        <div className="text-xs font-light">
          Make Model ID: {vehicle.make_model_id} | Last import:{' '}
          {vehicle.last_imported_at}
        </div>
      </div>

      {vehicleIsBlocked && <BlockedVehicleRow blockers={blockers} />}

      {!vehicleIsBlocked && (
        <div className="w-2/3 font-light text-right space-x-5">
          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/power_distributions`}
            className="btn py-1 px-2"
            title="Power Distribution"
          />
          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/importers`}
            className="btn py-1 px-2"
            title="Importers"
          />
          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/dtcs`}
            className="btn py-1 px-2"
            title="DTCs"
          />
          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/connector_views`}
            className="btn py-1 px-2"
            title="Vehicle Views"
          />
          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/edit`}
            className="btn py-1 px-2"
            title="Edit"
          >
            <Edit size="1.5rem" color="white" />
          </LinkWithStatus>
          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/edit`}
            className="btn py-1 px-2"
            title="Delete"
            onClickFunc={() => {
              props.deleteVehicle(vehicle.vehicle_id)
            }}
          >
            <TrashAlt size="1.5rem" color="white" />
          </LinkWithStatus>
        </div>
      )}
    </div>
  )
}

const VehiclesTable = (props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { vehicles, activityLogEnabled, pagination } = props
  const [searchQuery, setSearchQuery] = useState(
    searchParams.get('search') ? searchParams.get('search') : ''
  )

  const deleteVehicle = async (vehicle_make_id) => {
    if (
      window.confirm(`Are you really wan't to delete ${vehicle_make_id}`) ==
      true
    ) {
      let res = await deleteRequest(
        `/api/vehicles/delete_vehicle/${vehicle_make_id}/`
      )
      props.getPaginatedData()
    }
  }

  return (
    <div className="flex flex-col pt-6 flex-grow">
      <form
        className="flex flex-col w-full space-y-2 pb-5"
        action="/vehicles"
        acceptCharset="UTF-8"
        method="get"
      >
        <div className="flex space-x-5">
          <div className="w-1/3">
            <input
              autoComplete="off"
              className="w-full bg-white h-10 px-5 pr-5 rounded focus:outline-none"
              placeholder="Enter Vehicle Name"
              type="search"
              name="search"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value)
              }}
            />
          </div>
          <div className="w-2/3">
            <button className="bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded">
              Search
            </button>
          </div>
          <div className="w-2/3 font-light text-right space-x-5">
            <LinkWithStatus
              href={`/vehicles/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Create New Vehicle"
            />
          </div>
        </div>
      </form>
      <div className="flex flex-row bg-tracer-lt-blue rounded-t text-white px-3 text-sm font-light">
        <div className="w-full">Vehicle Name</div>
      </div>
      {vehicles.map((vehicle, index) => (
        <VehicleRow
          vehicle={vehicle}
          key={index}
          deleteVehicle={(vehicle_make_id) => deleteVehicle(vehicle_make_id)}
        />
      ))}
      {vehicles?.length < 1 && <NoRecordsFound loading={false} />}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            props.getPaginatedData(e)
          }}
          onClickPrev={(e) => {
            props.getPaginatedData(e)
          }}
        />
      </div>
    </div>
  )
}

VehiclesTable.propTypes = {
  vehicles: PropTypes.array.isRequired,
  activityLogEnabled: PropTypes.bool,
  searchQuery: PropTypes.string,
  pagination: PropTypes.object,
  getPaginatedData: PropTypes.func,
}

export default VehiclesTable
